import { JobStatus } from "~/graphql/supergraphEnums";
import type { BulkUploadRowData } from "./bulkUploadGraphqlDataSource";
import type { RowClassParams } from "ag-grid-community";

const STATUS_BACKGROUND_COLORS: Record<string, string> = {
  [JobStatus.Completed]: "#F0FDF4",
  [JobStatus.Error]: "#FEF2F2",
  [JobStatus.Queued]: "#F5F5F5",
};

export function getRowStyle(params: RowClassParams<BulkUploadRowData>) {
  const backgroundColor = params.data?.status
    ? STATUS_BACKGROUND_COLORS[params.data.status]
    : undefined;

  return backgroundColor ? { backgroundColor } : undefined;
}
